<template>
  <div class="layer-popup__container px-2 py-1">
    <!-- Title -->
    <div class="body-1 font-weight-bold">{{ title }}</div>

    <!-- Table -->
    <table v-if="table" class="mt-2">
      <tr v-for="(value, key) of table" :key="key">
        <td class="font-weight-bold pr-1 py-1" style="white-space: nowrap;">
          {{ key }}
        </td>
        <td
          v-html="value"
          style="border-bottom: 0.0625em solid rgba(0, 0, 0, 0.12)"
        />
      </tr>
    </table>

    <!-- Images -->
    <div v-if="images" class="d-flex mt-2" style="overflow-x: auto">
      <img
        class="popup__image mr-2"
        v-for="(link, index) of images"
        :key="`image-${index}`"
        :src="link"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      table: undefined,
      images: undefined
    };
  }
};
</script>

<style scoped>
.popup__image {
  width: auto;
  height: 7.5em;
}

table {
  border-collapse: collapse;
  width: 100%;
}
</style>
